<template>
  <div class="node-list-page">
    <Header :title="title" :showBack="true" />
    <SelectDate v-model:selectDate="selectDate" start-from-yesterday />


    <!-- 顶部：站点选择 + 过滤班次 + 日期 -->
    <div class="node-list-top">
      <div class="node-list-card bgfff">
        <div class="node-list-card__inner">
          <div class="node-list-station-row">
            <div class="node-list-station-input" @click="openStationPopup">
              <van-field
                :value="selectedStation ? selectedStation.NodeName : ''"
                placeholder="请选择站点"
                readonly
                :border="false"
              />
            </div>
            <van-button
              color="#ff9900"
              class="node-list-select-btn"
              @click="openStationPopup"
            >
              选择
            </van-button>
          </div>

          <div class="node-list-divider" />

          <div class="node-list-filter-row" @click="filterPickerVisible = true">
            <span class="node-list-filter-label">过滤班次：</span>
            <span class="node-list-filter-value">
              {{ filterLabel }}
              <van-icon name="arrow-down" color="#999" />
            </span>
          </div>

          <div class="node-list-divider" />
        </div>
      </div>
    </div>

    <!-- 班次列表 -->
    <div class="node-list-scroll" ref="wrapper">
      <van-pull-refresh
        v-model="listRefreshing"
        :disabled="!selectedStation"
        @refresh="onListRefresherRefresh"
      >
        <!-- 未选站点 -->
        <div
          v-if="listViewState === 'no-station'"
          class="node-list-empty"
        >
          <van-empty description="请先选择站点" />
        </div>

        <!-- 加载中 -->
        <div
          v-else-if="listViewState === 'loading'"
          class="node-list-empty node-list-empty--text"
        >
          加载班次中...
        </div>

        <!-- 无班次 -->
        <div
          v-else-if="listViewState === 'empty'"
          class="node-list-empty"
        >
          <van-empty description="暂无班次数据" />
        </div>

        <!-- 班次卡片 -->
        <div v-else class="node-list-cards">
          <div
            v-for="item in displayLineClassList"
            :key="item.GID"
            class="node-list-card-item bgfff"
          >
            <div class="node-list-card-head">
              <div class="node-list-card-head__main">
                <div class="node-list-card-time">
                  <van-icon name="clock-o" color="#ff9900" size="22" />
                  <span class="node-list-card-time__text">{{
                    formatClassTime(item.ClassTime)
                  }}</span>

                  <div class="node-list-card-stats">
                  <span>
                    未检:
                    <span class="text-danger">{{
                        item.NodeUnCheckCount || 0
                      }}</span>
                  </span>
                    <span>
                    已检:
                    <span class="text-success">{{
                        item.NodeCheckCount || 0
                      }}</span>
                  </span>
                  </div>
                </div>

              </div>
              <van-button
                color="#ff9900"
                size="small"
                class="node-list-action-btn"
                @click="gotoCheck(item)"
              >
                立即检票
              </van-button>
            </div>

            <div class="node-list-line-name">
              {{ item.LineName }}
            </div>

            <div
              v-for="vehicle in getVehicleList(item)"
              :key="vehicle.VehicleGID || vehicle.VehicleNo"
              class="node-list-vehicle-row"
            >
              <div class="node-list-vehicle-no bgf5">
                {{ vehicle.VehicleNo || "未派车" }}
              </div>
              <van-button
                color="#ff9900"
                size="small"
                class="node-list-action-btn"
                @click="onCheckVehicleDriverDetails(item, vehicle)"
              >
                车辆定位
              </van-button>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>

    <van-action-sheet
      v-model="filterPickerVisible"
      :actions="filterActions"
      cancel-text="取消"
      close-on-click-action
      @select="onFilterSelect"
    />

    <StationSelectPopup
      v-model="stationPopupVisible"
      :node-list="nodeList"
      :collect-node-list="collectNodeList"
      :loading="nodeListLoading"
      @select="onStationSelect"
      @collect="collectNode"
      @remove-collect="collectNodeRemove"
    />
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import SelectDate from "@/components/selectDate.vue";
import StationSelectPopup from "./components/StationSelectPopup.vue";
import dateCalendarStore from "../../stores/dateCalendarStore";
import {
  LINE_CLASS_TIME_FILTER_OPTIONS,
  filterLineClassByDepartTime,
  loadLineClassTimeFilter,
  loadSelectedStation,
  parseVehicleDriverList,
  saveLineClassTimeFilter,
  saveSelectedStation,
} from "./node-check-utils";

export default {
  components: {
    SelectDate,
    Header,
    StationSelectPopup,
  },
  data() {
    return {
      title: "站点检票",
      collectNodeList: [],
      nodeList: [],
      nodeListLoading: false,
      selectedStation: loadSelectedStation(),
      stationPopupVisible: false,
      filterPickerVisible: false,
      lineClassTimeFilterMinutes: loadLineClassTimeFilter(),
      lineClassListRaw: [],
      lineClassLoading: false,
      listRefreshing: false,
      scrollTop: 0,
      selectDate: dateCalendarStore.state.selectDate || new Date(),
      AllowedToQueryClassDaysAgo:
        this.$utils.getSysParams("AllowedToQueryClassDaysAgo") || "",
    };
  },
  computed: {
    filterLabel() {
      const opt = LINE_CLASS_TIME_FILTER_OPTIONS.find(
        (item) => item.minutes === this.lineClassTimeFilterMinutes
      );
      return opt ? opt.label : "不过滤";
    },
    filterActions() {
      return LINE_CLASS_TIME_FILTER_OPTIONS.map((item) => ({
        name: item.label,
      }));
    },
    queryDateStr() {
      return this.$moment(this.selectDate).format("YYYY-MM-DD");
    },
    displayLineClassList() {
      return filterLineClassByDepartTime(
        this.lineClassListRaw,
        this.lineClassTimeFilterMinutes,
        this.queryDateStr,
        this.$moment
      );
    },
    listViewState() {
      if (!this.selectedStation) return "no-station";
      if (this.lineClassLoading) return "loading";
      if (!this.displayLineClassList.length) return "empty";
      return "list";
    },
  },
  watch: {
    selectDate() {
      this.loadLineClassList();
    },
  },
  methods: {
    /**
     * AllowedToQueryClassDaysAgo 为 "min,max" 字符串（如 "-1,1" / "-2,1" / "-90,90"）。
     * 偏移约定：-1=今天，-2=昨天，1=明天，2=后天，以此类推（不使用 0）。
     * 选中日期对应偏移落在 [min, max] 内才允许查询。
     */
    isAllowedQueryDate(date) {
      const raw = String(this.AllowedToQueryClassDaysAgo || "").trim();
      if (!raw) return true;
      const parts = raw.split(",");
      if (parts.length < 2) return true;
      const min = parseInt(parts[0], 10);
      const max = parseInt(parts[1], 10);
      if (isNaN(min) || isNaN(max)) return true;
      // 相对今天的天数：今天=0，昨天=-1，明天=1
      const dayDiff = this.$moment(date)
        .startOf("day")
        .diff(this.$moment().startOf("day"), "days");
      // 转为参数偏移：今天 0 → -1，昨天 -1 → -2，明天 1 → 1
      const dayCode = dayDiff <= 0 ? dayDiff - 1 : dayDiff;
      return dayCode >= min && dayCode <= max;
    },
    formatClassTime(time) {
      return (time || "").substr(0, 5);
    },
    getVehicleList(item) {
      return parseVehicleDriverList(item.VehicleDriverList);
    },
    openStationPopup() {
      this.stationPopupVisible = true;
    },
    onFilterSelect(action) {
      const opt = LINE_CLASS_TIME_FILTER_OPTIONS.find(
        (item) => item.label === action.name
      );
      if (!opt) return;
      this.lineClassTimeFilterMinutes = opt.minutes;
      saveLineClassTimeFilter(opt.minutes);
    },
    onStationSelect(item) {
      this.selectedStation = item;
      saveSelectedStation(item);
      this.loadLineClassList();
    },
    async getData() {
      this.getCollectNode();
      await this.getCompanyStartNode();
      if (this.selectedStation && !this.lineClassListRaw.length) {
        this.loadLineClassList();
      }
    },
    isExistCollectNode(nodeGID) {
      return this.collectNodeList.findIndex((c) => c.NodeGID == nodeGID) > -1;
    },
    getCollectNode() {
      const collectNodeList = JSON.parse(
        window.localStorage.getItem("collectNodeList") || "[]"
      );
      this.collectNodeList = collectNodeList;
      return collectNodeList;
    },
    collectNode(e) {
      if (this.isExistCollectNode(e.NodeGID)) return;
      this.collectNodeList.push(e);
      window.localStorage.setItem(
        "collectNodeList",
        JSON.stringify(this.collectNodeList)
      );
      this.$toast.success("添加成功");
    },
    collectNodeRemove(e) {
      const index = this.collectNodeList.findIndex(
        (n) => n.NodeGID == e.NodeGID
      );
      if (index > -1) {
        this.collectNodeList.splice(index, 1);
        window.localStorage.setItem(
          "collectNodeList",
          JSON.stringify(this.collectNodeList)
        );
        this.$toast.success("移除成功");
      }
    },
    async getCompanyStartNode() {
      this.nodeListLoading = true;
      try {
        const res = await this.$http.post(this.$api.getCompanyStartNode, {});
        if (res.success) {
          this.nodeList = res.data || [];
        }
      } catch (res) {
        console.error("获取公司站点错误", res);
      } finally {
        this.nodeListLoading = false;
      }
    },
    loadLineClassList(options = {}) {
      if (!this.isAllowedQueryDate(this.selectDate)) {
        this.lineClassListRaw = [];
        this.$dialog.alert({
          title: "提示",
          message: "当前日期无查询权限",
        });
        return Promise.resolve();
      }

      const station = this.selectedStation;
      if (!station || !station.NodeGID) return Promise.resolve();

      if (!options.silent) this.lineClassLoading = true;

      const params = {
        NodeGID: station.NodeGID,
        BeginDate: this.$moment(this.selectDate).format("YYYY-MM-DD 00:00:00"),
        EndDate: this.$moment(this.selectDate).format("YYYY-MM-DD 23:59:59"),
        IsFilterLineOrganization: true,
      };

      return this.$http
        .post(this.$api.getNodeLineClassDay, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.lineClassListRaw = (res.data || []).map((item) => ({
              ...item,
              ClassTime: item.ClassTime ? item.ClassTime.substr(0, 5) : "",
            }));
          } else {
            this.lineClassListRaw = [];
          }
        })
        .catch((res) => {
          console.error("获取站点途径班次错误", res);
          this.lineClassListRaw = [];
        })
        .finally(() => {
          if (!options.silent) this.lineClassLoading = false;
        });
    },
    async onListRefresherRefresh() {
      if (!this.selectedStation || !this.selectedStation.NodeGID) {
        this.listRefreshing = false;
        return;
      }
      this.listRefreshing = true;
      try {
        await this.loadLineClassList({ silent: true });
      } finally {
        this.listRefreshing = false;
      }
    },
    onCheckVehicleDriverDetails(lineclassday, data) {
      window.localStorage.setItem(
        "lineClassDay",
        JSON.stringify(lineclassday)
      );
      try {
        window.localStorage.setItem(
          "vehicle-map-preview-info",
          JSON.stringify({
            VehicleGID: data.VehicleGID,
            VehicleNo: data.VehicleNo,
            PassengerSeatCount: data.PassengerSeatCount,
            Driver1Name: data.Driver1Name,
            Driver1Tel: data.Driver1Tel,
            Driver2Name: data.Driver2Name,
            Driver2Tel: data.Driver2Tel,
          })
        );
      } catch (e) {}
      this.$router.push({
        path: "VehicleMap",
        query: {
          VehicleGIDList: data.VehicleGID,
          entry: "nodeCheck",
          focusNodeGID: lineclassday.NodeGID || (this.selectedStation && this.selectedStation.NodeGID),
          NodeGeocoder: lineclassday.NodeGeocoder,
        },
      });
    },
    gotoCheck(lineclassday) {
      const node = { ...this.selectedStation,lineClassDayList:lineclassday};
      node.ClassTime = lineclassday.ClassTime.substr(0, 5);
      node.NodeGID = lineclassday.NodeGID;
      window.localStorage.setItem("lineClassDayStratNode", JSON.stringify(node));
      window.localStorage.setItem("lineClassDay", JSON.stringify(lineclassday));
      window.localStorage.setItem(
        "lineClassDayCheckedCount",
        lineclassday.CheckCount - lineclassday.NodeCheckCount
      );
      this.$router.push({
        name: "TicketCheck",
        params: {
          from: "NodeList",
        },
      });
    },
  },
  created() {
    this.getData();
  },
  beforeRouteLeave(to, from, next) {
    const list = this.$refs.wrapper;
    this.scrollTop = (list && list.scrollTop) || 0;
    next();
  },
  activated() {
    const cached = loadSelectedStation();
    const prevGid = this.selectedStation && this.selectedStation.NodeGID;
    if (cached) {
      this.selectedStation = cached;
    }
    if (
      this.selectedStation &&
      ((cached && cached.NodeGID !== prevGid) || !this.lineClassListRaw.length)
    ) {
      this.loadLineClassList({ silent: !!this.lineClassListRaw.length });
    }
    this.$nextTick(() => {
      if (this.$refs.wrapper) {
        this.$refs.wrapper.scrollTop = this.scrollTop;
      }
    });
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/") {
      dateCalendarStore.commit("initializeState", {
        selectDateIndex: 1,
        caldendarDefaultDate: new Date(),
        selectDate: new Date(),
        dateList: [],
      });
    }
    next();
  },
};
</script>

<style lang="less" scoped>
.node-list-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
}

.node-list-top {
  flex-shrink: 0;
  padding: 0 0.2rem 0.2rem;
}

.node-list-card {
  border-radius: 0.16rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &__inner {
    padding: 0.2rem 0.24rem 0;
  }
}

.node-list-station-row {
  display: flex;
  align-items: center;
  gap: 0.2rem;
}

.node-list-station-input {
  flex: 1;
  min-width: 0;
  background: #f5f5f5;
  border-radius: 10px;
  overflow: hidden;

  /deep/ .van-cell {
    background: transparent;
    padding: 0.16rem 0.28rem;
  }

  /deep/ .van-field__control {
    font-size: 0.38rem;
  }
}

.node-list-select-btn {
  flex-shrink: 0;
  min-width: 1.4rem;
  height: 0.8rem;
  border-radius: 0.12rem;
  font-size: 0.36rem;
}

.node-list-divider {
  height: 1px;
  background: #f0f0f0;
  margin: 0.2rem 0;
}

.node-list-filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 0;
  font-size: 0.36rem;
}

.node-list-filter-label {
  color: #333;
}

.node-list-filter-value {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  color: #666;
}

.node-list-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 0.2rem 0.2rem;
}

.node-list-empty {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 0;

  &--text {
    color: #999;
    font-size: 0.38rem;
  }
}

.node-list-cards {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-height: 50vh;
}

.node-list-card-item {
  border-radius: 0.16rem;
  padding: 0.24rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.node-list-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.2rem;
  margin-bottom: 0.16rem;

  &__main {
    flex: 1;
    min-width: 0;
  }
}

.node-list-card-time {
  display: flex;
  align-items: center;
  gap: 0.1rem;
  margin-bottom: 0.1rem;

  &__text {
    font-size: 0.44rem;
    font-weight: bold;
    color: #ff9900;
  }
}

.node-list-card-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.24rem;
  font-size: 0.32rem;
  color: #666;
  margin-left: 0.3rem;

  .text-danger {
    color: #ff4d4f;
    font-weight: 500;
  }

  .text-success {
    color: #52c41a;
    font-weight: 500;
  }
}

.node-list-action-btn {
  flex-shrink: 0;
  min-width: 1.6rem;
  height: 0.64rem;
  font-size: 0.32rem;
  border-radius: 8px;
}

.node-list-line-name {
  font-size: 0.36rem;
  color: #333;
  text-align: left;
  margin-bottom: 0.16rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.node-list-vehicle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.2rem;
  margin-bottom: 0.12rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.node-list-vehicle-no {
  flex: 1;
  min-width: 0;
  padding: 0.2rem 0.24rem;
  border-radius: 0.12rem;
  font-size: 0.34rem;
  color: #333;
  text-align: left;
}
</style>
